import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Layout from "../components/Layout/Layout";
import AuthRoute from "../pages/Auth/AuthRoute";
import Login from "../pages/Auth/Login";
import ResetPassword from "../pages/Auth/ResetPassword";
import PrivateRoutes from "../pages/PrivateRoutes";

const CompanyRoute = lazy(() => import("../components/Companies/Company.jsx"));
const CompaniesRoute = lazy(() => import("../components/Companies/Companies.jsx"));
const CreateCompanyRoute = lazy(() =>
  import("../components/Companies/CreateCompany.jsx")
);

const StoreHousesRoute = lazy(() => import("../components/StoreHouses/Storehouses.jsx"));
const CreateStorehouseRoute = lazy(() =>
  import("../components/StoreHouses/CreateStorehouse")
);
const StorehouseRoute = lazy(() => import("../components/StoreHouses/Storehouse"));

const UsersRoute = lazy(() => import("../components/Users/Users.jsx"));
const UserRoute = lazy(() => import("../components/Users/User.jsx"));
const CreateUserRoute = lazy(() => import("../components/Users/CreateUser.jsx"));

const ProductTypesRoute = lazy(() =>
  import("../components/ProductTypes/ProductTypes.jsx")
);
const CreateProductTypeRoute = lazy(() =>
  import("../components/ProductTypes/CreateProductType")
);
const ProductTypeRoute = lazy(() => import("../components/ProductTypes/ProductType"));

const CreateStockRoute = lazy(() => import("../components/Stocks/CreateStock"));
const StockRoute = lazy(() => import("../components/Stocks/Stock"));
const StocksRoute = lazy(() => import("../components/Stocks/Stocks.jsx"));

const TicketsRoute = lazy(() => import("../components/Tickets/Tickets"));
const CreateTicketRoute = lazy(() => import("../components/Tickets/CreateTicket"));
const TicketRoute = lazy(() => import("../components/Tickets/Ticket"));

const NotFoundRoute = lazy(() => import("../pages/NotFoundPage"));

const Routes = () => {
  return (
    <Router>
      <Switch>
        <AuthRoute exact path="/" component={Login} />
        <AuthRoute path="/reset" component={ResetPassword} />

        <PrivateRoutes>
          <Layout>
            <Suspense fallback={<div />}>
              <Switch>
                <Route exact path="/storehouses" component={StoreHousesRoute} />
                <Route
                  exact
                  path="/storehouses/create"
                  component={CreateStorehouseRoute}
                />
                <Route path="/storehouses/:id" component={StorehouseRoute} />

                <Route exact path="/product-types" component={ProductTypesRoute} />
                <Route
                  exact
                  path="/product-types/create"
                  component={CreateProductTypeRoute}
                />
                <Route path="/product-types/:id" component={ProductTypeRoute} />

                <Route exact path="/stocks" component={StocksRoute} />
                <Route exact path="/stocks/create" component={CreateStockRoute} />
                <Route path="/stocks/:id" component={StockRoute} />

                <Route exact path="/companies" component={CompaniesRoute} />
                <Route exact path="/companies/create" component={CreateCompanyRoute} />
                <Route path="/companies/:id" component={CompanyRoute} />

                <Route exact path="/users" component={UsersRoute} />
                <Route exact path="/users/create" component={CreateUserRoute} />
                <Route path="/users/:id" component={UserRoute} />

                <Route exact path="/tickets" component={TicketsRoute} />
                <Route exact path="/tickets/create" component={CreateTicketRoute} />
                <Route path="/tickets/:id" component={TicketRoute} />

                <Route component={NotFoundRoute} />
              </Switch>
            </Suspense>
          </Layout>
        </PrivateRoutes>
      </Switch>
    </Router>
  );
};

export default Routes;
